import styled from 'styled-components';

import { theme } from '_constants/theme';
import { ICONS_ALIASES, ICONS_PALETTE } from '_constants/icons';

import FancyCards from '_components/atomic/FancyCards';

const { colors, devices, fontSizes, spaces } = theme;

const ITEMS = [
  {
    title: 'Expertise',
    description: (
      <>
        Attorney-led professionals handle the process and ensure that your
        trademark application is complete and meets all legal requirements.
      </>
    ),
    iconAlias: ICONS_ALIASES.feedback,
    iconPalette: ICONS_PALETTE.green[ICONS_ALIASES.feedback],
    color: colors.green[25],
  },
  {
    title: 'Convenience',
    description: (
      <>
        Save time and hassle by letting experts handle the paperwork and filing
        process.
      </>
    ),
    iconAlias: ICONS_ALIASES.saveEnergy,
    iconPalette: ICONS_PALETTE.indigo[ICONS_ALIASES.saveEnergy],
    color: colors.indigo[25],
  },
  {
    title: 'Error Prevention',
    description: (
      <>
        Avoid costly mistakes and rejections (known as Office Actions) by having
        an expert review your application before it&apos;s filed. If you receive
        an Office Action rejection, we will help fix it.
      </>
    ),
    iconAlias: ICONS_ALIASES.cancel,
    iconPalette: ICONS_PALETTE.green[ICONS_ALIASES.cancel],
    color: colors.green[25],
  },
  {
    title: 'Success Rate',
    description: (
      <>
        Increased chances of success with a service that has a proven track
        record of successful trademark registrations.
      </>
    ),
    iconAlias: ICONS_ALIASES.development,
    iconPalette: ICONS_PALETTE.indigo[ICONS_ALIASES.development],
    color: colors.indigo[25],
  },
  {
    title: 'Peace of mind',
    description: (
      <>
        Peace of mind knowing that your trademark is in good hands and that you
        have a team of experts working to protect your brand.
      </>
    ),
    iconAlias: ICONS_ALIASES.reduceStress,
    iconPalette: ICONS_PALETTE.green[ICONS_ALIASES.reduceStress],
    color: colors.green[25],
  },
];

const StyledRegisteringTMInfoSection = styled.div`
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${devices.tablet} {
    padding: ${spaces.regular}px;
  }
`;

const StyledTitle = styled.div`
  margin-bottom: ${spaces.large9X}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.large11X}px;
  line-height: 150%;
  text-align: center;
  color: ${colors.gray[800]};

  @media ${devices.tablet} {
    margin-bottom: ${spaces.medium}px;
    font-size: ${fontSizes.large2X}px;
  }
`;

const StyledDescription = styled.div`
  margin-bottom: ${spaces.large9X}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.medium}px;
  line-height: 150%;
  text-align: center;
  color: ${colors.gray[600]};

  @media ${devices.tablet} {
    margin-bottom: ${spaces.medium}px;
    font-size: ${fontSizes.regular}px;
  }
`;

const RegisteringTMInfoSection = () => {
  return (
    <StyledRegisteringTMInfoSection>
      <StyledTitle>Registering Your Trademark with Incorpified</StyledTitle>
      <StyledDescription>
        Incorpified can help you register your trademark quickly and
        efficiently. Our team of experts will ensure that your application is
        complete and meets all legal requirements, and we provide personalized
        attention and guidance throughout the process. A few benefits of using
        our service:
      </StyledDescription>
      <FancyCards maxCol={3} items={ITEMS} />
    </StyledRegisteringTMInfoSection>
  );
};

export default RegisteringTMInfoSection;
